module.exports = __webpack_public_path__ + "images/sd-05-faq-desktop.png";